import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const InspectionScheduleDashboard = lazyLoader(
  () =>
    import(
      "Containers/Inspections/InspectionScheduleDashboard/InspectionSchedule"
    )
);

export const InspectionSchedule = () => {
  return (
    <Layout>
      <InspectionScheduleDashboard />
    </Layout>
  );
};
